<template>
    <v-app id="inspire" v-show="isMainAppVisible" :style="{backgroundColor: '#EAF0F3'}">
        <template v-if="$store.state.UserInfo.isLogged ">
            <template v-if="!$route.path.includes('login')" >
				<div class="top-strip">
					<v-app-bar 
						app 
						:clipped-left="$vuetify.breakpoint.lgAndUp" 
						dark 
						color="primary" 
						dense 
						:style="{ marginLeft: sideMargin, marginRight: sideMargin, marginTop: '10px'}"
					>
						<v-badge v-model="isUpdateBadgeVisible" color="error" offset-y="20" offset-x="20" dot>
							<v-app-bar-nav-icon @click.stop="drawer = !drawer" title="Click for more options"></v-app-bar-nav-icon>
						</v-badge>
						<v-app-bar-title>
							<span :class="[$vuetify.breakpoint.mdAndUp ? 'h1' : 'subtitle-1']" >
								仕様検討ツール依頼システム(SHIYOUSHO REQUEST SYSTEM) {{$store.state.Master.UIVersion}} 
							</span>
							<span v-if="debugMode" class="white--text h1" style="background-color: red">
								&nbsp;(DEBUG MODE)&nbsp;
							</span>
						</v-app-bar-title>
						<v-spacer />
						<v-icon @click="showUpdatesHistory()" dark title="updates">mdi-information </v-icon>
						<span class="hidden-sm-and-down pl-3">{{ UserName }} &nbsp;</span>
						<v-icon @click="logout()" dark >mdi-logout </v-icon>
					</v-app-bar>
				</div>
                <v-app-bar app hide-details clipped-left dense :style="{ top: ($vuetify.application.top - 100) + 'px', backgroundColor: '#FFFFFF', marginLeft: sideMargin, marginRight: sideMargin, marginTop: '10px'}" >
                    <template v-if="this.$route.name !== 'Feedback'">
                        <v-app-bar-title>
                            <div class="d-flex w-100">
                                <v-text-field class="pt-6 planInfo planInfoWide" label="お客様コード(ConstructionCode)" readonly dense :value="ConstructionCode" ></v-text-field>
                                <v-text-field class="pt-6 planInfo planInfoNarrow" label="図面番号(PlanNo)" readonly dense :value="RevisionNumber" ></v-text-field>
                                <v-text-field class="pt-6 planInfo planInfoShio" label="仕様書番号(ShioNo)" readonly dense :value="RequestNumber" ></v-text-field>
                                <v-text-field class="pt-6 planInfo planInfoMedium" label="家タイプ(HouseType)" readonly dense :value="HouseType" ></v-text-field>
                                <template v-if="$store.state.PlanInfo.JibanInfo.CopiedPlanInfo" >
                                    <v-text-field class="pt-6 planInfo" label="コピー元(CopyNo)" readonly dense :value="copiedPlanNumber" ></v-text-field>
                                </template>
                            </div>
                        </v-app-bar-title>
                        <v-spacer></v-spacer>
                        <template v-for="request in MasterSheets">
                            <v-toolbar-items :key="request.japanesename">
                                <v-btn text :class="request.class" :disabled="$store.state.PlanInfo.ConstructionCode == '' || $store.state.UserInterface[request.englishname + 'Loading'] ? true:false" @click="goToSheet(request)">
                                    <v-progress-circular v-if="isSheetTabLoading(request.englishname)" indeterminate color="primary" size="20" width="2" class="mr-2" />
                                    {{ request.japanesename }}
                                </v-btn>
                                <v-divider inset vertical></v-divider>
                            </v-toolbar-items>
                        </template>
                    </template>
                    <template v-else>
                        <v-app-bar-title>
                            <span>{{ this.$route.name }}... &nbsp;<v-icon>mdi-message</v-icon></span>
                        </v-app-bar-title>
                    </template>
                    <v-app-bar app clipped-left dense hide-details :style="{ top: ($vuetify.application.top - 100) + 'px', height: '40px', backgroundColor: '#FFFFFF', marginTop: '5px'}" >
                        <span color="#E0E0E0">&nbsp;<b>{{ $store.state.PlanInfo.CurrentMenu }}</b></span>
                        
                        <template v-if="isShioCheckSheetButtonShown">
                            <v-spacer />
                            <v-btn small color="primary" class="mb-2" @click="getShiyoCheckSheet($route.name)">
                                <v-icon left dark>
                                    mdi-playlist-check
                                </v-icon>
                                仕様チェックシート
                            </v-btn>
                        </template>
                     </v-app-bar>
                </v-app-bar>
                
                <div class="drawer-wrapper" :style="drawerWrapperStyle">
                    <v-navigation-drawer
                        v-model="drawer"
                        absolute
                        temporary
                        hide-overlay
                        height="100%"
						class="elevation-0"
						floating
                        :style="{ ...drawerStyle, pointerEvents: 'auto' }"
                    >
                    <v-list nav dense>
                        <v-list-item-group v-model="group" >
                            <template v-for="(item, i) in navBarItems"> 
                                <template v-if="item.id !== 5">
                                    <v-list-item @click="hideDrawer(item.id)"  :key="item.id+'_'+i" >
                                        <v-icon>
                                            {{item.icon}}
                                        </v-icon> 
                                        &emsp;
                                        <template v-if="item.id == 2">
                                            <v-badge v-model="isUpdateBadgeVisible" color="error" dot>
                                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                                            </v-badge>
                                        </template>
                                        <template v-else>
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                                        </template>
                                    </v-list-item>
                                    <v-divider v-if="item.id == 3" />
                                </template>
                                <template v-else>
                                    <v-list>
                                        <v-list-group :value="false">
                                            <template v-slot:activator>
                                                <v-icon>{{item.icon}}</v-icon> &emsp;
                                                <v-list-item-title >{{ item.text }}</v-list-item-title>
                                            </template>
                                            <template v-for="(display, index) in displaySetting">
                                                <v-list-item :key="index">
                                                    <v-list-item-content >
                                                        <v-checkbox hide-details mandatory class="shrink mt-0 pl-5" v-model="displaySelected" :value="display">
                                                            <template v-slot:label>
                                                                <span class="text-body-2">{{ display.text }}</span>
                                                            </template>
                                                        </v-checkbox>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-list-group>
                                    </v-list> 
                                </template>
                            </template>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
                </div>
            </template>
        </template>

            <loader v-if="LoadingValue" :loadingDisplay="LoadingDisplay" :loadingPercentage="LoadingPercentage" />
 
            <edit-value v-if="editDialog" :editDialog="editDialog" :items="editParam" /> 
			
			<data-extraction-dialog v-model="showDataExtraction" />

        <div
            :style="{
                backgroundColor: '#FFFFFF',
                marginLeft: sideMargin,
                marginRight: sideMargin,
				maxHeight: '50vh',
				marginTop: '10px',
            }"
        >
            <router-view :key="currentUrlId" />
        </div>
     </v-app>
</template>
<script>
    import { bus } from './../app'
    import { clearPersistedState } from './../store' //2026-10-07 jazz
    
    import { isOtherTabOpen } from './../pageListener'; //2025-09-05 jazz

    export default {
        name: 'App',

        components: {
            EditValue: () => import('./SRSParts/SubComponents/EditValue'),
            Loader: () => import('./SRSParts/SubComponents/Loader'),
			DataExtractionDialog: () => import('./SRSParts/SubComponents/DataExtractionDialog'),
        },
        
        beforeDestroy: function() {
            for(const property in this.$data){
                this.$data[property] = null
            }

            bus.$off('changeUser')
            bus.$off('showEdit')
	
            //added by mae unable to close/refresh SRS if saving plan is running
            window.removeEventListener("beforeunload", this.preventNav);
        },

        data: () => ({
            debugMode: null,
            displaySetting: [
                { id: 1, text: 'カテゴリー別(Category)' },
                { id: 2, text: '全表示(All)' }
            ],
            displaySelected: null,
            isUpdateBadgeVisible: false,
            newVersion: null,
            drawer: false,
            group: null,
            // shortcutCheckbox: false, 2025-08-22 jazz
            // selectedMaster: null, 2025-08-22 jazz
            navBarItems: [
                { 
                    id: 1, 
                    icon: "mdi-menu-open", 
                    text: "作成依頼(Menu)", 
                    to: "/menu", 
                    isAdmin: 0, 
                    comment: "Menu" 
                },
                { 
                    id: 2, 
                    icon: "mdi-database-edit", 
                    text: "ｱｯﾌﾟﾃﾞｰﾄ(Update)", 
                    to: "", 
                    isAdmin: 0, 
                    comment: "Update App" 
                },

                { 
                    id: 5, 
                    icon: "mdi-cog", 
                    text: "表示設定(Display Setting)", 
                    to: "", 
                    isAdmin: 0, 
                    comment: "Display Settings" 
                },
                { 
                    id: 4, 
                    icon: "mdi-list-status", 
                    text: "Plan Status Viewer", 
                    to: "/planview", 
                    isAdmin: 0, 
                    comment: "Feedback" 
                },
				
				//Added Mae 2026-10-27
				{ 
					id: 6, 
					icon: "mdi-database-export", 
					text: "DATA Extraction", 
					to: "", 
					isAdmin: 0, 
					comment: "Data Extraction" 
				},
				
                // { id: 3, icon: "mdi-message", text: "ﾌｨｰﾄﾞﾊﾞｯｸ(Feedback)", to: "", isAdmin: 0, comment: "Feedback" },
            ],
            //2025-08-22 jazz
            // dialogPosition: {
            //     screenTop: 400,
            //     screenLeft: document.documentElement.clientWidth / 2
            // },
            mainDrawer: false,
            fullname: '',
            // loadingDialog: false, 2025-08-22 jazz
            // confirmationDlg: false, 2025-08-22 jazz
            editDialog: false,
            editParam: {},
            navDialog: false,
            // AppInfo: '', 2025-08-22 jazz
            notifyDialog: {
                buttoncaption: null,
                function: null,
                title: {
                    caption: null,
                    class: null,
                    color: null,
                },
                message: null,
            },
            size: 20,
            LoadingValue: false,
            LoadingDisplay: '',
            LoadingPercentage: 0,
            fromRoute: null,
            currRoute: null,
            environment: null,
            isMainAppVisible: true,
			showDataExtraction: false,
        }),
		
		created(){
			//Added Mae 2026-10-27 == remember the DATA Extraction item so it can be added back later ==
			this.dataExtractionItem = this.navBarItems.find(item => item.id === 6);
			this.applyDataExtractionMenu();
		},
	
        async mounted(){
            //2025-07-11 jazz
            this.environment = process.env.MIX_ENVIRONMENT;
 
            //2025-09-05 jazz
            isOtherTabOpen(this.fromRoute)

            localStorage.openpages = Date.now();

            //2025-09-05 jazz
            // Broadcast that you're opening a page.
            //localStorage.openpages = Date.now();
            //       var onLocalStorageEvent = function(e){
            //           if(e.key == "openpages"){
            //               // Listen if anybody else is opening the same page!
            //               localStorage.page_available = Date.now();
            //           }
            //           if(e.key == "page_available"){
            //               alert("Please close SRS in other browser tabs");
            //               // window.location.replace(`about:blank`)
            //           }
            //       };

            if(this.$store.state.UserInterface.isCategoryOnly){
                this.displaySelected = {id: 1, text:'カテゴリー別(Category)'}
            }else{
                this.displaySelected = {id: 2, text: '全表示(All)'}
            }
            
            // window.addEventListener('storage', onLocalStorageEvent, false);

            bus.$on('IsUpdateBadgeVisible', (data) =>{
                this.isUpdateBadgeVisible = data;
            })

            //2025-10-03 jazz, hide main app
            bus.$on('setMainAppVisibility', (data) =>{
                this.isMainAppVisible = data;
            })

            this.$store.dispatch('EditKey', '-1')

            bus.$on('showLoadingProgress', (data) =>{
                this.LoadingDisplay = data.LoadingDisplay;
                this.LoadingPercentage = data.LoadingPercentage
                this.LoadingValue = data.LoadingValue;
            })

            bus.$on('changeUser', (data) => {
                this.fullname = data
            })

            bus.$on('resetDisplay', () =>{
                if(this.$store.state.UserInterface.isCategoryOnly){
                    this.displaySelected = {id: 1, text:'カテゴリー別(Category)'}
                }else{
                    this.displaySelected = {id: 2, text: '全表示(All)'}
                }
            })

            bus.$on('hideDrawer', () =>{
                this.mainDrawer = false
            })

            bus.$on('showEdit', (data) => {
                this.editDialog = data.isshown
                this.editParam = data               
            })
          
            bus.$on('showNotifyDialog', (data) =>{
                bus.$emit('ShowNotifyDialog', data.isshown);
                this.notifyDialog = data
            })

            if((/true/i).test(process.env.MIX_DEBUG)){
                this.debugMode = true;
                this.databaseName = `Database: ${process.env.DB_DATABASE}`
            }else{
                this.debugMode = false;
            }

            this.fullname = this.UserName
			
            if ( ( /ichijo/i ).test( process.env.MIX_DEPLOYMENT ) ) {
                //if refresh page, connect to socket if logged jazz 2024-08-30
                if ( this.$store.state.UserInfo.isLogged && this.$store.state.UserInfo.FullName != '' ){
                    //2024-09-09 jazz modify socket to connect when logged
                    await this.$WebsocketService.connect( this.$store.state.UserInfo.FullName );
                    await this.$WebsocketService.joinRoom({systemName: "SRS", roomName: process.env.MIX_SOCKET_ROOM, userName: this.$store.state.UserInfo.FullName })
                    this.$ConnectionId = await this.$WebsocketService.getConnectionId()
                 }
            }
            
            //2025-12-26 jazz
            if( ( /hrd/i ).test( process.env.MIX_DEPLOYMENT )){
                this.navBarItems = this.navBarItems.filter(item => item.id != 5)
            }else{
                this.navBarItems = this.navBarItems.filter(item => item.id != 4)
            }
			
			window.addEventListener("beforeunload", this.preventNav);
        },

        computed: {
		
			//Added Mae 2026-10-27 == DATA Extraction: show ONLY when HRD mode AND admin == 1 ==
			canUseDataExtraction() {
				const isHrd   = ( /hrd/i ).test( process.env.MIX_DEPLOYMENT || '' );
				const isAdmin = Number( this.$store.state.UserInfo.isAdmin ) === 1; // true only for 1 or "1"

				return isHrd && isAdmin;
			},
		
		
			//added mae 2026-10-31
			drawerWrapperStyle() {
				return {
					position: 'fixed',
					top: '145px',                 // height of the dense blue app bar
					bottom: '0',
					left: this.sideMargin,       // same as v-app-bar marginLeft
					width: '256px',
					zIndex: 7,
					pointerEvents: 'none',
					overflow: 'hidden',          // clips the drawer when it slides out
					visibility: this.drawer ? 'visible' : 'hidden',
					transition: 'visibility 0s linear ' + (this.drawer ? '0s' : '0.2s'),
				};
			},
		
		
		
	         // Added Mae 2026-09-29
	        drawerStyle() {
	            return {
	                backgroundColor: '#FFFFFF',
	            };
	        },
	        
	        sideMargin() {
	             //const width = this.$vuetify.breakpoint.width;
				 
	             //if (width <= 1293) return "0px";
	             //if (width < 1500) return "50px";
	             //if (width < 1600) return "90px";
	             //if (width < 1700) return "120px";
	             //if (width < 1800) return "160px";
	             //if (width < 2000) return "200px";
	             //if (width < 2500) return "350px";
	             //return "500px";
				 return "0px";
	        },
	        
            ConstructionCode: function () {
                return this.$store.state.PlanInfo.ConstructionCode;
            },

            RevisionNumber: function () {
                return this.$store.state.PlanInfo.RevisionNumber;
            },

            RequestNumber: function () {
                return this.$store.state.PlanInfo.RequestNumber;
            },

            HouseType: function () {
                return this.$store.state.PlanInfo.HouseType;
            },

            UserName: function () {
                return this.$store.state.UserInfo.UserName;
            },

            MasterSheets: function () {
                return this.$store.state.UserInterface.SheetItems;
            },

            copiedPlanNumber: function () {
                return this.$store.state.PlanInfo.JibanInfo.CopiedPlanInfo.RevisionNumber +
                    '-' + this.$store.state.PlanInfo.JibanInfo.CopiedPlanInfo.RequestNumber;
            },

            isShioCheckSheetButtonShown: function () {
                let result = false;

                if (this.$store.state.PlanInfo.HRDSQL2SiyoCode !== '') {
                    if (['GaibuList', 'BasicSpecs', 'SetsubiSheet'].includes(this.$route.name)) {
                        result = true;
                    }
                }

                return result;
            },

            //2025-08-05 jazz
            currentUrlId() {
                return window.location.pathname.replace(/\//g, '-').substring(1) || 'home';
            }
        },

        beforeRouteEnter (to, from, next) {
            next( async vm => { 
                vm.fromRoute = from.name
                vm.currRoute = to.name

                //2025-12-03 jazz
                if(!vm.$store.state.BypassOn){
                      alert('WARNING!!!\nOnly open this app from the CAD Request System')
                      await new Promise(r => setTimeout(r, 100));
                      window.location.replace('about:blank')
                }
            })
        },  

        watch: {
            group () {
                if(this.group !== 3){
                    this.drawer = false   
                } 
            },

            displaySelected: function (newValue, oldValue){
                let tmpResult = false;
                if(newValue == null){
                    alert('cannot be empty')
                    newValue = {id: 2, text: '全表示(All)'}
                    return;
                }else{
                    if(newValue.id == 1){
                        tmpResult = true
                    }
                }

                this.$store.dispatch('isCategoryOnly', tmpResult)
                bus.$emit('changeDisplay', tmpResult)
            },
			
			//Added Mae 2026-10-27
			canUseDataExtraction(){
				this.applyDataExtractionMenu();
			},
			
        },

        methods:{
			//Added Mae 2026-10-27 == show/hide DATA Extraction only ==
			applyDataExtractionMenu(){
				if (!this.navBarItems || !this.dataExtractionItem) return; // beforeDestroy sets data to null

				const exists = this.navBarItems.some(item => item.id === 6);

				if (this.canUseDataExtraction && !exists) {
					this.navBarItems.push(this.dataExtractionItem);
				} else if (!this.canUseDataExtraction && exists) {
					this.navBarItems = this.navBarItems.filter(item => item.id !== 6);
				}
			},
		
            //2026-10-13 jazz, show a spinner on the Gaibu/Setsubi tab buttons while their background load is
            //running. Also require ConstructionCode to be set - resetUserInterface defaults these Loading
            //flags to true as a "not loaded yet" placeholder (e.g. while the 作成(Create) dialog is shown,
            //before any plan is open), which isn't an actual background load.
            isSheetTabLoading(englishname){
                return this.$store.state.PlanInfo.ConstructionCode !== '' &&
                    ['GaibuList', 'SetsubiSheet'].includes(englishname) &&
                    this.$store.state.UserInterface[englishname + 'Loading'];
            },

            async getShiyoCheckSheet(routeName){
                if ( ( /ichijo/i ).test( process.env.MIX_DEPLOYMENT ) ) {
                    this.$ProgressBar.show();
                    this.$ProgressBar.functionCount = 20;
 
                    const planDetails = {
                        constructionCode: this.$store.state.PlanInfo.ConstructionCode,
                        planNumber      : this.$store.state.PlanInfo.RevisionNumber,
                        siyoCode        : this.$store.state.PlanInfo.HRDSQL2SiyoCode, 
                        routeName       : routeName 
                    }

                    let tmpObj = {
                        requestData : planDetails,
                        request     : 'getShioPDF@SS',
                        requestorConnectionId: (await this.$WebsocketService.getConnectionId())
                    }

                    this.$WebsocketService.sendMessage(
                        { 
                            systemName: "SRS", 
                            roomName  : process.env.MIX_SOCKET_ROOM, 
                            userName  : this.$store.state.UserInfo.FullName, 
                            data      : this.$SRSFunc.SRSDefaults.CompressData( tmpObj )
                        }, 
                        this.$store.state.Master.UIVersion 
                    );
                }else{
                    const res = await this.$Axios.get(`api/generate-shio-pdf`, {
                        params: {
                            construction_code: this.$store.state.PlanInfo.ConstructionCode,
                            siyo_code: this.$store.state.PlanInfo.HRDSQL2SiyoCode,
                            kbn: routeName
                        },
                        responseType: 'blob'  
                    });

                    const pdfFile = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(pdfFile);

                    // Define window features for the new window
                    const windowFeatures = 'width=800,height=600,resizable=yes,scrollbars=yes';

                    // Open the PDF in a new window with specified features
                    const newWindow = window.open(url, '_blank', windowFeatures);

                    // Check if the new window was successfully opened
                    if (newWindow) {
                        newWindow.focus(); // Bring the new window to the front
                    } else {
                        // Handle the case where the new window could not be opened (e.g., popup blocker)
                        alert('Please allow popups for this website to view the PDF.');
                    }

                    // Clean up the object URL after a short delay
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                    }, 100); 
                }
            },
		
            //added by mae unable to close/refresh SRS if saving plan is running
            preventNav(event) {
                if (this.$store.state.UserInterface.isRunSaving) {
                     if (event) {

                        //Log the warning
                        this.$SRSFunc.SRSDefaults.Logger(
                            'warning',
                            this.$store.state.UserInfo.FullName,
                            'Summary.vue',
                            'User attempted to navigate away while saving data',
                            1
                        );

                        // Set a generic confirmation message
                        const confirmationMessage = this.$Const.USER_INTERUPT_SAVING_PROCESS;
                        
                        // Prevent the default action and set the return value for the confirmation dialog
                        event.preventDefault();
                        event.returnValue = confirmationMessage; 

                        // Log the user's decision asynchronously
                        this.handleUserDecision(confirmationMessage);

                     }
                }
            },

			//added by mae Custom dialog
            handleUserDecision(message) {

                // Simulate an asynchronous user decision process
                setTimeout(() => {
                    const userConfirmed = confirm(message); // This will show the confirmation dialog

                    if ( userConfirmed ) {

                        // Log the user's decision to leave
                        this.$SRSFunc.SRSDefaults.Logger(
                            'info',
                            this.$store.state.UserInfo.FullName,
                            'Summary.vue',
                            'browser close notification. User chose to leave the page during save operation. The plan did not saved properly. The Data in Boss and HRD did not send',
                            1
                        );

                        this.$swal({
                            text: this.$Const.RESUBMIT_UNSAVED_PLAN,
                            icon:'warning',
                            className:"swalError",
                            buttons:{
                                text:"ok",
                            }
                        })

                    } else {
                        
                        // Log the user's decision to stay
                        this.$SRSFunc.SRSDefaults.Logger(
                            'info',
                            this.$store.state.UserInfo.FullName,
                            'Summary.vue',
                            'browser close notification. User chose to stay on the page to save the plan.',
                            1
                        );

                        this.$swal({
                            text: this.$Const.WAITING_INFO,
                            icon:'info',
                            className:"swalError",
                            buttons:{
                                text:"ok",
                            }
                        })

                    }
                }, 0);

            },
			
            async setView(){
                await this.$store.dispatch('EditKey', '-1')
            },

            async goToSheet(sheet){
                this.$ProgressBar.show();
                this.$ProgressBar.functionCount = 20;
                this.$ProgressBar.increment();

                this.$store.dispatch('updateSheetItems', sheet)

                await new Promise(r => setTimeout(r, 100));

                this.$ProgressBar.increment();

                await this.$SRSFunc.SRSDefaults.setActiveSheetInViewAndIDB(sheet, this.$ProgressBar, true, true);  

                this.setView()
            },

            logout(){
                this.$swal.fire({
                    html: 'ログアウトしてもよろしいですか？<br><br>Are you sure you want to logout?',
                    icon: 'question',
                    width: '400px',
                    focusCancel: true,
                    allowOutsideClick: false,
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",                            
                    confirmButtonText: 'はい(Y)',
                    cancelButtonText: 'いいえ(N)'
                }).then((result) => {
                    if (result.isConfirmed) {
                        try{
                            bus.$emit('changeUser', '');
                            this.$UserInfo.logOutUser();
                            this.$SRSFunc.SRSDefaults.Logger('info', this.$store.state.UserInfo.FullName, 'App.vue', 'user logout', 1)
                            this.$SRSFunc.SRSDefaults.setActiveSheetInViewAndIDB('', false) 
                            //this.$SRSDatabase.resetBossSendTable();
                        }finally{
                           window.location.replace(`${process.env.MIX_API_BASEURL}/login`) // 2024-10-11
                        }
                    }
                });
            },

            //2025-08-22 jazz
            // isChangeConfirmationVisible(id){
            //     let result = true

            //     if(this.$store.state.PlanInfo.isPrevious == true && !this.$store.state.PlanInfo.CopyPlan){
            //         result = false
            //     }

            //     return result
            // },

            hideDrawer(id){
						
				//Added Mae 2026-10-27
				if( id === 6 ){
					this.drawer = false;
					if( this.canUseDataExtraction ){
						this.showDataExtraction = true;
					}
					return;
				}
			
                async function clearAssets(swal){
                    clearPersistedState();

                    swal.fire({
                        icon: "info",
                        width: '350px',
                        text: 'SRSデータがクリアされました',
                        showConfirmButton: false,
                        timer: 2000
                    }) 

                    await new Promise(r => setTimeout(r, 2000));

                    window.location.reload(true)
                }

                if(!this.$route.meta.isAllowUpdate){
                    let tmpHtmlInfo = `${this.$Const.CHANGE_ROUTE_WARNING_JAPANESE} <br><br> ${this.$Const.CHANGE_ROUTE_WARNING_ENGLISH}`
                    let tmpIcon = 'question'

                    if( id === 2 ){
                        tmpHtmlInfo = `${this.$Const.WARNING_UPDATE_SRS_MASTER_JAP} <br><br> ${this.$Const.WARNING_UPDATE_SRS_MASTER_ENGLISH}`
                        tmpIcon = 'warning'
                    }

                    this.$swal({
                        html: tmpHtmlInfo,
                        icon: tmpIcon,
                        width: '400px',
                        focusCancel: true,
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",                            
                        confirmButtonText: 'はい(Y)',
                        cancelButtonText: 'いいえ(N)' 
 
                    }).then( async (result) => {
                        if (result.isConfirmed) {
                            this.$store.commit('resetPlanInfo');
                            
                            switch(id){
                                case 1:
                                    await new Promise(r => setTimeout(r, 500)); //2025-07-07 jazz, add to avoid warnings 
                                    this.$router.push('/menu'); 
                                    break;
                                case 2: clearAssets(this.$swal); break;
                                case 3: this.$router.push('/feedback'); break;
                                case 4:
                                    await new Promise(r => setTimeout(r, 500));  
                                    this.$router.push('/planview'); 
                                    break;
                            }
                        }
                    });
                }
            },

            async showUpdatesHistory(){
                this.$SRSFunc.SRSDefaults.Logger('info', this.$store.state.UserInfo.FullName, 'App.vue', `open version history`, 1)  

                const response = await this.$Axios.get('/api/version-history')
                const versionInfo = response.data;

                let template = `<table border="1px solid red" width="100%" style="border-collapse: collapse;">
                                    <th style="background-color: rgb(217,217,217); width: 150px;">
                                        Version
                                    </th>
                                    <th style="background-color: rgb(217,217,217); width: 1500px;">
                                        Details
                                    </th>
                                    <th style="background-color: rgb(217,217,217); width: 200px;">
                                        Date
                                    </th>
                                `;

                for(let i = 0; i < versionInfo.length; i++){
                    let bgColor = null;
                    if(i == 0){
                        bgColor = '#90f5b5';
                    }

                    template = `${template}
                        <tr> 
                            <td style="text-align: left; background-color: ${bgColor}">v1.${versionInfo[i].revision}.${versionInfo[i].version}</td>   
                            <td style="text-align: left; background-color: ${bgColor}">${versionInfo[i].update_description.message}</td>
                            <td style="text-align: left; background-color: ${bgColor}">${versionInfo[i].updated_at.split('T')[0]}</td>
                        </tr>`
                }
                
                template = `${template}</table>`
                
                this.$swal.fire({
                    html: template,
                    width: '1200px',
                    confirmButtonColor: "#3085d6",
                    customClass:{
                        htmlContainer: 'versionInfoDialog'
                    }

                });
            }

        }
    };
</script>